import React, { useEffect, useState } from "react";
import LoadingPage from "../Loading/loading";
import { useNavigate } from "react-router-dom";
import { Cookies } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";
import { createProject, getRegions } from "../../network/api/projects";

const AddProjectPage = (props) => {
  const navigate = useNavigate();
  const [regions, setRegions] = useState(null);
  const [loading, setLoading] = useState();

  const [formData, setFormData] = useState({
    name: "",
    region: "",
  });

  const handleChange = (e) => {
    e.target.setCustomValidity("");
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    createProject({ name: formData.name, region: formData.region }).then(
      (result) => {
        if (result.data.message === "Created successfully") {
          toast.success(result.data.message, {
            position: "top-right",
          });
          props.changeToView("View Projects");
        } else {
          toast.error(result.data.message, {
            position: "top-right",
          });
        }
        setLoading(false);
      },
    );
  };

  useEffect(() => {
    getRegions().then((result) => {
      setRegions(result.data.response);
    });
  }, []);

  return (
    <>
      {!regions ? (
        <LoadingPage />
      ) : (
        <div className="add-brokers-guideline">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="Name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter Name"
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Name is required")
                }
              />
            </div>

            <div className="form-group">
              <label htmlFor="region">Region</label>
              <select
                className="form-select form-control form-select-lg border border-dark"
                aria-label="Select Region"
                name="region" // Changed from type2 to be more descriptive
                value={formData.region}
                onChange={(e) => {
                  e.target.setCustomValidity("");
                  setFormData({
                    ...formData,
                    region: e.target.value,
                  });
                }}
                style={{
                  width: "100%",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "16px",
                  backgroundColor: "#fff",
                  cursor: "pointer",
                }}
                required
                onInvalid={(e) =>
                  e.target.setCustomValidity("Region is required")
                }
              >
                <option disabled value="">
                  Select Region
                </option>
                {regions?.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            {loading ? (
              <div
                style={{
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <div className="spinner"></div>
              </div>
            ) : (
              <button type="submit" className="submit-button">
                Add Project
              </button>
            )}
          </form>
          <ToastContainer />
        </div>
      )}
    </>
  );
};

export default AddProjectPage;
